import {SkeletonBox} from '@primer/react/experimental'

import styles from './CounterSkeleton.module.css'

export function CounterSkeleton() {
  return <SkeletonBox className={styles.counterSkeleton} data-testid="counter-skeleton" />
}
